import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import ResponsiveImage from './ResponsiveImage';

export function ItemImage(props) {
    const {
        photoIndex,
        item, // eslint-disable-line no-unused-vars
        relay, // eslint-disable-line no-unused-vars
        ...otherProps
    } = props;
    const photo = props.item.photos[photoIndex];

    return <ResponsiveImage {...otherProps} photo={photo} />;
}

ItemImage.propTypes = {
    item: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    isClient: PropTypes.bool.isRequired,
    photoIndex: PropTypes.number,
};

ItemImage.defaultProps = {
    photoIndex: 0,
};

export default createFragmentContainer(ItemImage, {
    item: graphql`
        fragment ItemImage_item on Item {
            photos(limit: 1) {
                largePath
                masterOrZoomPath
            }
        }
    `,
});
